/**
 * Pre-compiled en messages for SplitButton
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { noActionsAvailable: `No actions available` };
